export function limitInsulinDigits(value: number | undefined): number {
  if (value === undefined || isNaN(value)) {
    return NaN
  }

  // Count integer digits
  const absValue = Math.abs(value)
  const intPart = Math.trunc(absValue)
  const intDigits = intPart === 0 ? 1 : Math.floor(Math.log10(intPart)) + 1

  // Limit fractional digits based on integer length, up to 3 decimals.
  // This preserves at most 5 digits when possible, but leaves integers with
  // more than 5 digits unchanged by allowing 0 decimals.
  const allowedDecimals = Math.max(
    0,
    Math.min(
      3,
      5 - intDigits,
    ),
  )

  // Truncate only (no rounding)
  const multiplier = Math.pow(
    10,
    allowedDecimals,
  )
  return Math.trunc(value * multiplier) / multiplier
}
